"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import ItemElementShops from "../../../elements/ItemElementShops.vue";
let ColumnProxy = class extends Vue {
  get add() {
    return this._column.status !== "release";
  }
  bindshop() {
    this.$emit("createshop", this._column);
  }
};
__decorateClass([
  PropSync("column")
], ColumnProxy.prototype, "_column", 2);
ColumnProxy = __decorateClass([
  Component({
    components: {
      ItemElementShops
    }
  })
], ColumnProxy);
export {
  ColumnProxy as default
};
